import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilsService } from './utils.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const loggedIn = UtilsService.getUserToken();
  const loggedInButExpired = UtilsService.isTokenExpired(loggedIn);
  if (loggedIn == null || loggedInButExpired) {
    router.navigate(['/unauthorized']);
    return false;
  }
  return true;
};
